import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormService } from '../../form.service';
import { BaseControlValueAccessorComponent } from '../base-control-value-accessor/base-control-value-accessor.component';

@Component({
  selector: 'app-textarea-input',
  templateUrl: './textarea-input.component.html',
  styleUrls: ['./textarea-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaInputComponent),
      multi: true,
    },
  ],
})
export class TextareaInputComponent extends BaseControlValueAccessorComponent implements OnInit, OnDestroy {
  @Input() placeholder: string | undefined = '';
  @Input() ariaLabel = '';
  @Input() charLimit: number | undefined = undefined;
  @Input() regex: string | null = null;
  @Input() required = false;
  @Input() width = 100;
  @Input() formControl = new UntypedFormControl('');
  charCounterSubscription: Subscription;
  charCounter = null;
  constructor(public formService: FormService) {
    super();
  }

  ngOnInit(): void {
    this.setValidatorToFormControls();
    this.charCounterSubscription = this.formControl.valueChanges.subscribe((val) => {
      this.charCounter = val?.length ? val.length : 0;
    });
  }

  setValidatorToFormControls(): void {
    if (this.required) {
      this.placeholder = this.placeholder + ' *';
    }
  }
  ngOnDestroy(): void {
    this.charCounterSubscription.unsubscribe();
  }
}
